function RegulationsHeader() {
  return (
    <div className="pb-2">
      <div>
        <p className="m-0 text-xl text-deepAqua font-bold">הוסיפו רגולציות</p>

        <div className="w-[636px]">
          <p className="m-0 mt-2 text-base text-darkerGray">
            הוסיפו את הרגולציות שבארגונכם. באפשרותכם להעלות קבצים ולשייך אותם
            לרגולציה. לקבוע את סוגה ולקבוע התראות לפני מועד ביצוע.
          </p>
        </div>
      </div>
    </div>
  );
}

export default RegulationsHeader;
